//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { convertTime, formatTime } from '../../../components/helpers.js'
import { EventBus } from '../../../EventBus/EventBus.js'

import ReportMaterialsTable from './ReportMaterialsTable.vue'
import ReportMaterialsDebitEditor from './ReportMaterialsDebitEditor.vue'
import ReportRemarkImportantCheckbox from '../ReportRemarkImportantCheckbox.vue'
import { formatRecId, formatTrueFalse, setPreciseAmount, getTagByKey } from './ReportMaterialsHelperFunctions.js'

export default {
  components: {
    ReportMaterialsTable,
    ReportRemarkImportantCheckbox
  },
  props: {
    debits: {
      type: Array,
      default () {
        return []
      }
    },
    debitError: {
      type: Object,
      default () {
        return null
      }
    },
    materialesAvailable: {
      type: Array,
      default () {
        return []
      }
    },
    mountings: {
      type: Array,
      default () {
        return []
      }
    },
    demountings: {
      type: Array,
      default () {
        return []
      }
    },
    projects: {
      type: Array,
      default () {
        return []
      }
    },
    tags: {
      type: Array,
      default () {
        return []
      }
    },
    serviceObject: {
      type: Object,
      default () {
        return {}
      }
    },
    reportId: {
      type: Number,
      default: 0
    },
    reportRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    checking: {
      type: Boolean,
      default: false
    },
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    reportActionsAccess: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      debit: { // TODO delete
        toolKey: null,
        toolName: null,
        stockKey: null,
        stockName: null,
        amount: null,
        loops: null,
        hasLoops: false,
        projectKey: null,
        projectName: null,
        note: null,
        noted: null,
        sn: null,
        recId: null,
        df: null,
        comment: null,
        mountingId: null,
        demountingId: null,
        tag: null,
        isSegment: false
      },

      fixProjectKey: null,
      fixProjectName: null,

      setPreciseAmount: setPreciseAmount,

      modalDeleteDebitOpened: false,
      selectedItemsLength: 0,

      updateSegmentHandler: null,

      convertTime: convertTime,

      columns: [
        {
          name: 'toolName',
          label: 'Название',
          align: 'left',
          field: 'toolName',
          sortable: true,
          defaultWidth: 200
        },
        {
          name: 'toolKey',
          label: 'ID номенклатурной позиции в 1С',
          align: 'left',
          field: 'toolKey',
          sortable: true,
          defaultWidth: 200
        },
        {
          name: 'amount',
          label: 'Кол-во',
          align: 'left',
          field: 'amount',
          sortable: true
        },
        {
          name: 'unit',
          label: 'Ед. изм.',
          align: 'left',
          field: 'unit',
          sortable: true
        },
        {
          name: 'loops',
          label: 'Кол-во петель',
          align: 'left',
          field: 'loops',
          sortable: true
        },
        {
          name: 'stockName',
          label: 'Склад',
          align: 'left',
          field: 'stockName',
          sortable: true,
          defaultWidth: 100
        },
        {
          name: 'sn',
          label: 'Серийный номер',
          align: 'left',
          field: 'sn',
          sortable: true
        },
        {
          name: 'projectName',
          label: 'Проект',
          align: 'left',
          field: 'projectName',
          sortable: true,
          defaultWidth: 200
        },
        {
          name: 'mountingId',
          label: 'Монтаж',
          align: 'left',
          field: 'mountingId',
          sortable: true,
          format: this.formatMountingId,
          defaultWidth: 200
        },
        {
          name: 'demountingId',
          label: 'Замена',
          align: 'left',
          field: 'demountingId',
          sortable: true,
          format: this.formatDemountingId,
          defaultWidth: 200
        },
        {
          name: 'delivered',
          label: '1C',
          align: 'left',
          field: 'delivered',
          sortable: true,
          format: formatTrueFalse,
          defaultWidth: 100
        },
        {
          name: 'tag',
          label: 'Тег',
          align: 'left',
          field: 'tag',
          format: tag => getTagByKey(tag, this.tags),
          sortable: true,
          defaultWidth: 100
        },
        {
          name: 'comment',
          label: 'Комментарий исполнителя',
          align: 'left',
          field: 'comment',
          sortable: true
        },
        {
          name: 'noted',
          label: 'Результат проверки',
          align: 'left',
          field: 'noted',
          sortable: true
        },
        {
          name: 'note',
          label: 'Замечание аналитика',
          align: 'left',
          field: 'note',
          sortable: true
        },
        {
          name: 'df',
          label: 'Учёт в ДФ',
          align: 'left',
          field: 'df',
          sortable: true,
          format: formatTrueFalse,
          defaultWidth: 100
        },
        {
          name: 'changed',
          label: 'Изменено',
          align: 'left',
          field: 'changed',
          sortable: true,
          format: formatTrueFalse,
          defaultWidth: 100
        },
        {
          name: 'time',
          label: 'Дата/время',
          align: 'left',
          field: 'time',
          sortable: true,
          format: formatTime,
          defaultWidth: 150
        },
        {
          name: 'user',
          label: 'Сотрудник',
          align: 'left',
          field: 'user',
          sortable: true,
          defaultWidth: 200
        }
      ]
    }
  },
  created: function () {
    this.updateSegmentHandler = (data) => {
      if (this.report.key !== data.reportKey) {
        return
      }
      const selectedSegment = data.segment

      if (data.operation.type === 'delete') {
        // обрабатывается в монтаже
      } else {
        if (selectedSegment.mountingId) {
          const mounting = this.mountings.find(mounting => mounting.recId === selectedSegment.mountingId)
          if (mounting && mounting.sourceTable === 'debit') {
            const debit = this.debits.find(debit => debit.mountingId === mounting.recId)
            if (debit) {
              this.onEditDebit(debit)
            }
          } else {
            // обрабатывается в монтаже и расходе
          }
        }
      }
    }

    EventBus.$on('mounting-segment', this.updateSegmentHandler)
  },
  beforeDestroy: function () {
    EventBus.$off('mounting-segment', this.updateSegmentHandler)
  },
  methods: {
    onSelectedItems: function (selectedItemsLength) {
      this.selectedItemsLength = selectedItemsLength
    },
    onAddDebit: function (operation, demountingId, selectedSegment) {
      if (operation !== 'mounting' && operation !== 'replacement') {
        operation = null
      }
      if (operation !== 'replacement') {
        demountingId = null
      }

      const dialog = this.$d.dialog(this).show({
        maximizedOnNarrow: true,
        persistent: true,
        noWrap: true,
        contentWidth: 560,
        contentComponent: ReportMaterialsDebitEditor,
        contentProps: {
          record: null,
          isEdit: false,
          operation: operation,
          // ===
          fixProjectKey: this.fixProjectKey,
          fixProjectName: this.fixProjectName,
          materialesAvailable: this.materialesAvailable,
          // ===
          debits: this.debits,
          mountings: this.mountings,
          demountings: this.demountings,
          projects: this.projects,
          tags: this.tags,
          serviceObject: this.serviceObject,
          report: this.report,
          reportActionsAccess: this.reportActionsAccess
        },
        componentHandlers: {
          save: ({ debit }) => {
            dialog.hide()
            this.onSaveAddDebit(debit, operation, demountingId, selectedSegment)
          },
          close: () => {
            dialog.hide()
            this.onCloseAddDebit(operation, demountingId)
          }
        }
      })
    },
    onAddRemark: function () {
      if (this.report.debitRemarks.length === 0) {
        this.report.debitRemarks.push({
          active: true,
          done: false,
          code: 'debitRemarks',
          comment: null,
          important: false
        })
      } else {
        this.report.debitRemarks[0].active = true
      }
    },
    onDeleteRemark: function () {
      if (this.report.debitRemarks.length !== 0) {
        this.report.debitRemarks[0].active = false
      }
    },
    onApproveSelectedDebits: function () {
      this.$refs.reportMaterialsTable.$refs.reportMaterialsTableDispatcher.approveSelectedItems()
    },
    onChangeProjects: function () {
      this.$refs.reportMaterialsTable.$refs.reportMaterialsTableDispatcher.onChangeProjects()
    },
    onEditDebit: function (record) {
      const index = this.debits.indexOf(record)

      const dialog = this.$d.dialog(this).show({
        maximizedOnNarrow: true,
        persistent: true,
        noWrap: true,
        contentWidth: 560,
        contentComponent: ReportMaterialsDebitEditor,
        contentProps: {
          record: record,
          isEdit: true,
          operation: null,
          // ===
          fixProjectKey: null,
          fixProjectName: null,
          materialesAvailable: this.materialesAvailable,
          // ===
          debits: this.debits,
          mountings: this.mountings,
          demountings: this.demountings,
          projects: this.projects,
          tags: this.tags,
          serviceObject: this.serviceObject,
          report: this.report,
          reportActionsAccess: this.reportActionsAccess
        },
        componentHandlers: {
          save: ({ debit, amountAvailable }) => {
            dialog.hide()
            this.onSaveEditDebit(debit, index, amountAvailable)
          },
          close: () => dialog.hide()
        }
      })
    },
    setDebitValues: function (row) {
      if (row) {
        this.debit.toolKey = row.toolKey
        this.debit.toolName = row.toolName
        this.debit.stockKey = row.stockKey
        this.debit.stockName = row.stockName
        this.debit.amount = row.amount
        this.debit.loops = row.loops
        this.debit.hasLoops = row.hasLoops
        this.debit.unit = row.unit
        this.debit.unit2 = row.unit2
        this.debit.maxUnit2 = row.maxUnit2
        this.debit.projectKey = row.projectKey
        this.debit.projectName = row.projectName
        this.debit.note = row.note
        this.debit.noted = row.noted
        this.debit.sn = row.sn
        this.debit.recId = row.recId
        this.debit.df = row.df
        this.debit.tag = row.tag
        this.debit.comment = row.comment
        this.debit.mountingId = row.mountingId
        this.debit.demountingId = row.demountingId
        this.debit.isSegment = row.isSegment
      } else {
        this.debit.toolKey = null
        this.debit.toolName = null
        this.debit.stockKey = null
        this.debit.stockName = null
        this.debit.amount = null
        this.debit.loops = null
        this.debit.hasLoops = false
        this.debit.unit = null
        this.debit.unit2 = null
        this.debit.maxUnit2 = null
        this.debit.projectKey = null
        this.debit.projectName = null
        this.debit.note = null
        this.debit.noted = null
        this.debit.sn = null
        this.debit.recId = null
        this.debit.df = null
        this.debit.tag = null
        this.debit.comment = null
        this.debit.mountingId = null
        this.debit.demountingId = null
        this.debit.isSegment = false
        this.editedMaterial = null
      }
    },
    onDeleteDebit: function (row) {
      this.setDebitValues(row) // TODO remove
      this.modalDeleteDebitOpened = true
    },
    onCloseDeleteDebit: function () {
      this.setDebitValues(null) // TODO remove
      this.modalDeleteDebitOpened = false
    },
    onSaveDeleteDebit: function () {
      const debit = this.debit
      const index = this.debits.findIndex(item => item.recId === debit.recId)
      this.debits.splice(index, 1) // TODO delete debit

      if (debit.mountingId) {
        const indexMounting = this.mountings.findIndex(mounting => mounting.recId === debit.mountingId)
        this.mountings.splice(indexMounting, 1) // TODO delete mounting
      }

      this.materialesAvailable.forEach(item => {
        if (item.amount && item.toolKey === debit.toolKey) {
          for (let i = 0; i < item.stockKey.length; i++) {
            if (item.stockKey[i] === debit.stockKey) {
              item.amount[i] = Math.round((item.amount[i] + debit.amount) * 100) / 100
            }
          }
        }
      })

      const materialesAvailable = JSON.parse(JSON.stringify(this.materialesAvailable))
      this.$emit('change-materiales-available', materialesAvailable)
      this.onCloseDeleteDebit()
    },
    onSaveEditDebit: function (debit, index, amountAvailable) {
      const originalInitial = this.debits[index] ? this.debits[index]._initial : undefined
      debit = JSON.parse(JSON.stringify(debit)) // TODO new debit
      if (originalInitial !== undefined) {
        Object.defineProperty(debit, '_initial', {
          value: originalInitial,
          writable: false,
          enumerable: false,
          configurable: true
        })
      }
      this.debits.splice(index, 1, debit) // TODO update debit

      let needAddToMaterialsAvailable = false
      this.materialesAvailable.forEach(item => {
        if (item.amount && item.toolKey === debit.toolKey) {
          for (let i = 0; i < item.stockKey.length; i++) {
            if (item.stockKey[i] === debit.stockKey) {
              item.amount[i] = Math.round((amountAvailable - debit.amount) * 100) / 100
            } else {
              needAddToMaterialsAvailable = false
            }
          }
          needAddToMaterialsAvailable = true
        }
      })
      if (needAddToMaterialsAvailable === false) {
        const materialesAvailableItemImitation = {
          amount: [Math.round((amountAvailable - debit.amount) * 100) / 100],
          stockKey: [debit.stockKey],
          stockName: [debit.stockName],
          toolKey: debit.toolKey,
          toolName: debit.toolName,
          unit: debit.unit,
          unit2: debit.unit2,
          maxUnit2: debit.maxUnit2
        }
        if (materialesAvailableItemImitation.amount !== 0) {
          this.materialesAvailable.push(materialesAvailableItemImitation)
        }
      }

      if (debit.mountingId) {
        const mounting = this.mountings.find(mounting => mounting.recId === debit.mountingId)
        mounting.toolKey = debit.toolKey
        mounting.toolName = debit.toolName
        mounting.amount = debit.amount
        mounting.unit = debit.unit
        mounting.sn = debit.sn
        mounting.tag = debit.tag
      }

      const materialesAvailable = JSON.parse(JSON.stringify(this.materialesAvailable))
      this.$emit('change-materiales-available', materialesAvailable)

      // common

      this.fixProjectKey = debit.projectKey
      this.fixProjectName = debit.projectName
    },
    onSaveAddDebit: function (debit, operation, demountingId, selectedSegment) {
      if (operation === 'mounting' || operation === 'replacement') {
        const mounting = {} // TODO new mounting
        mounting.toolKey = debit.toolKey
        mounting.toolName = debit.toolName
        mounting.amount = debit.amount
        mounting.unit = debit.unit
        mounting.sn = debit.sn
        mounting.tag = debit.tag
        mounting.sourceTable = 'debit'
        mounting.recId = new Date().getTime()
        this.mountings.push(mounting) // TODO add mounting

        debit.mountingId = mounting.recId

        if (selectedSegment) {
          selectedSegment.mountingId = mounting.recId
          debit.isSegment = true
          mounting.isSegment = true
        }
        if (operation === 'replacement') {
          debit.demountingId = demountingId
        }
      }

      debit.recId = new Date().getTime()

      debit = JSON.parse(JSON.stringify(debit)) // TODO new debit
      this.debits.push(debit) // TODO add debit

      this.materialesAvailable.forEach(item => {
        if (item.amount && item.toolKey === debit.toolKey) {
          for (let i = 0; i < item.stockKey.length; i++) {
            if (item.stockKey[i] === debit.stockKey) {
              item.amount[i] = Math.round((item.amount[i] - debit.amount) * 100) / 100
            }
          }
        }
      })
      const materialesAvailable = JSON.parse(JSON.stringify(this.materialesAvailable))
      this.$emit('change-materiales-available', materialesAvailable)

      // common

      this.fixProjectKey = debit.projectKey
      this.fixProjectName = debit.projectName
    },
    onCloseAddDebit: function (operation, demountingId) {
      if (operation === 'replacement') {
        this.$parent.$parent.$parent.$parent.$refs.demountings.onDeleteDemounting(demountingId)
      }
    },

    formatMountingId: function (value) {
      return formatRecId(value, this.mountings)
    },
    formatDemountingId: function (value) {
      return formatRecId(value, this.demountings)
    }
  }
}

